import Form from '@appComponents/ReduxFormControls';
import ClipProvidersDropdown from '@modules/clipConfiguration/components/ClipProvidersDropdown';
import { BASE_FORM_MESSAGES } from '@constants/messages';
import {EVENT} from '@constants/resources';
import {SetCoverageToEvents} from '@graphql/events/mutation';
import {GetOptionsForSetCoverageForm} from '@graphql/events/query';


export default function SetCoverageModel() {
    return {
        title: null,
        formName: 'SetCoverageToMultipleEvents',
        entityDataMapKey: 'SetCoverageToMultipleEvents',
        resources: EVENT,
        dataMap: {
            products: [],
        },
        fields: {
            products: {
                optionsKey: 'coverage',
                props: {
                    className: 'inline',
                    component: Form.SemanticCheckboxList,
                    label: 'Coverage',
                    name: 'coverage',
                    inline: true,
                },
            },
            clip_providers: {
                optionsKey: 'clipProviders',
                props: {
                    displayBlock: true,
                    component: ClipProvidersDropdown,
                    label: null,
                    name: 'clip_providers',
                    hidden: true,
                    products: [],
                    eventContentTypes: [],
                    defaultDropdownValue: '',
                },
            },
        },
        messages: {
            boxName: {
                delete: 'eventsIndex',
                success: 'eventsIndex',
                error: 'formInnerErrorMessage',
            },
            text: {
                ...BASE_FORM_MESSAGES,
                SAVED: () => 'The selected events have had their coverage set successfully.',
                FORM_ERROR: () => 'The selected events could not have their coverage set successfully.',
                NOT_SAVED: () => '',
            },
        },
        mutation: {
            updateEntity: SetCoverageToEvents,
        },
        query: {
            getOptions: GetOptionsForSetCoverageForm,
        },
    };
}
